define([
    "util"
], function (
    Util
) {
    class CloudService {

        constructor (args) {
            if (!args || typeof args !== "object" || !args.dao) {
              throw new TypeError("Invalid args argument");
            }
            this.dao = args.dao;
        }

        getDAO () { return this.dao; }

        async refreshCloudData () {
            return await this.getDAO().getCCAPI("cloud", "resource", "id", "refresh-cloud-data", {"refresh":"true"}, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }

        async crawlCloudAccounts (credId) {
            if (!credId) {
                credId = "all";
            }
            // cloud/resource/${credID?credID:"all"}/crawl?refresh=false
            return await this.getDAO().getCCAPI("cloud", "resource", credId, "crawl", {"refresh":"false"}, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }

        async listRegions (credId, provider, subscriptionId) {
            if (!credId || typeof credId !== 'string') {
                throw new TypeError("Invalid credId argument");
            }
            if (!provider || typeof provider !== 'string') {
                throw new TypeError("Invalid provider argument");
            }
            const params = {provider: provider};
            if (subscriptionId) {
                params.subscription_id = subscriptionId;
            }
            return await this.getDAO().getCCAPI("cloud", "resource", credId, "list-regions", params, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }

    }
    return CloudService;
});
